import React from 'react';
import { Helmet } from 'react-helmet';
import { Switch, Route, Redirect } from 'react-router-dom';

// Global workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Global Components
import EntitiesSaveErrorModal from 'components/EntitiesSaveErrorModal';
import HarvestEventsSaveErrorModal from 'components/HarvestEventsSaveErrorModal';
// @ts-ignore
import Online from 'components/Online';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import InitialDataLoadedErrorGate from 'components/InitialDataLoadedErrorGate';
// @ts-ignore
import InitialDataLoadedGate from 'components/InitialDataLoadedGate';
import ResetSelectedTableCellsOnCurrentEntityIdUpdate from 'components/ResetSelectedTableCellsOnCurrentEntityIdUpdate';
// @ts-ignore
import SplashScreen from 'components/SplashScreen';

// Global Scenes
// @ts-ignore
import Areas from 'scenes/Areas';
import Harvest from 'scenes/Harvest';
import Jobs from 'scenes/Jobs';
import Workforce from 'scenes/Workforce';
import Spray from 'scenes/Spray';
// @ts-ignore
import Time from 'scenes/Time';
import Fertilizer from 'scenes/Fertilizer';
import Settings from 'scenes/Settings';

// Local Components
import ScaffoldDataRequest from './components/ScaffoldDataRequest';
// @ts-ignore
import OrganizationsRedirect from './components/OrganizationsRedirect';
import SidebarNavigation from './components/SidebarNavigation';
// @ts-ignore
import SidebarNavigationPusher from './components/SidebarNavigationPusher';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

const Organization = (): React.ReactElement => (
    <ErrorBoundary
        namespace="Organization"
        FallbackComponent={<ErrorBoundaryAlert />}
    >
        <Helmet>
            <title>
                {'Organization - '}
                {REACT_APP_PROJECT_NAME}
            </title>
        </Helmet>
        <OrganizationsRedirect />
        <ResetSelectedTableCellsOnCurrentEntityIdUpdate />
        <Online>
            <ScaffoldDataRequest />
        </Online>
        <InitialDataLoadedErrorGate
            namespace="SCAFFOLD_DATA_LOAD"
            displayLogoutButton
        >
            <InitialDataLoadedGate
                namespace="SCAFFOLD_DATA_LOAD"
                LoadingComponent={<SplashScreen />}
            >
                <SidebarNavigation />
                <SidebarNavigationPusher>
                    <Switch>
                        <Redirect
                            exact
                            from="/organization"
                            to="/organization/harvest"
                        />
                        <Route
                            path="/organization/harvest"
                            component={Harvest}
                        />
                        <Route path="/organization/jobs" component={Jobs} />
                        <Route path="/organization/areas" component={Areas} />
                        <Route
                            path="/organization/workforce"
                            component={Workforce}
                        />
                        <Route path="/organization/time" component={Time} />
                        <Route path="/organization/spray" component={Spray} />
                        <Route
                            path="/organization/fertilizer"
                            component={Fertilizer}
                        />
                        <Route
                            path="/organization/settings"
                            component={Settings}
                        />
                        <Redirect
                            from="/organization/*"
                            to="/organization/harvest"
                        />
                    </Switch>
                </SidebarNavigationPusher>
                <EntitiesSaveErrorModal />
                <HarvestEventsSaveErrorModal />
            </InitialDataLoadedGate>
        </InitialDataLoadedErrorGate>
    </ErrorBoundary>
);

export default Organization;
